<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive" >
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>
   
    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      
      <b-navbar-nav class="nav align-items-center ml-auto">
        <CartDropdown></CartDropdown>
        <!-- <locale /> -->
        <dark-Toggler class="d-none d-lg-block" />
      </b-navbar-nav>

      

      
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown right toggle-class="d-flex align-items-center dropdown-user-link" class="dropdown-user" >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0"> {{ userData.fullName }} </p>
            <span class="user-status">{{ userData.role }}</span>
          </div>
          <b-avatar size="40" variant="light-primary" badge :src="userData.avatar" class="badge-minimal" badge-variant="success" />
        </template>

        <b-dropdown-item :to="{ name: 'profile' }" link-class="d-flex align-items-center">
          <feather-icon size="16" icon="UserIcon" class="mr-50" />
          <span>{{$t('Profile')}}</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span>{{$t('Logout')}}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import { BLink, BNavbarNav, BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar, } from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import DarkToggler from '@core/layouts/components/app-navbar/components/DarkToggler.vue'
import Locale from '@core/layouts/components/app-navbar/components/Locale.vue'
import store from '@/store'
import CartDropdown from './CartDropdown.vue'


export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    DarkToggler,
    Locale,
    CartDropdown
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    logout() {
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
      localStorage.removeItem('userData')
      localStorage.removeItem('shoppingBasket')
      localStorage.removeItem('cashSelected')
      localStorage.removeItem('vspanel-skin')
      if (!localStorage.getItem('vspanel-skin')){
        if (window.matchMedia("(prefers-color-scheme: dark)").matches){
          document.body.classList.add('dark-layout')
          store.commit('appConfig/UPDATE_SKIN', "dark")
        }
        else document.body.classList.remove('dark-layout')
      }
      // this.$ability.update(initialAbility)
      this.$router.push({ name: 'login' })
    },
},
}
</script>
